import { Component, OnInit, ViewEncapsulation, ViewChild } from '@angular/core';
import {MenuItem, LazyLoadEvent,} from 'primeng/api';
import {SearchPageThemeService} from '../../services';
import { SearchPageTheme } from '../../models';
import { IGlobalSearchParam, ISearchGlobalFilter } from '../../../shared/models/Global-Search.model';
import {DialogService} from 'primeng/dynamicdialog';
import {DynamicDialogRef} from 'primeng/dynamicdialog';
import { Message } from 'primeng/api';
import { PrimeNGConfig } from 'primeng/api';
import { ConfirmationService, ConfirmEventType, MessageService } from 'primeng/api';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import { DatePipe } from '@angular/common';
import { SharedService } from '../../../shared/services/shared.service';
import { SelectItem, FilterService, FilterMatchMode } from "primeng/api";
import { Table } from 'primeng/table';
//import { LookupCategory } from 'src/app/admin/models';
import { ILookupCategory } from '../../../shared/models/lookup.model';
import { LookupCategory } from '../../../shared/enums/EnumsVMS';
import { ExcelService } from '../../../shared/services/excel.service';
import { Router, ActivatedRoute } from '@angular/router';
import * as fs from 'file-saver';

@Component({
  selector: 'app-search-page-theme',
  templateUrl: './search-page-theme.component.html',
  styleUrls: ['./search-page-theme.component.css'],
  encapsulation: ViewEncapsulation.None,
  providers: [DialogService, ConfirmationService, MessageService]
})
export class SearchPageThemeComponent implements OnInit {

  loggedInUserProfile;
   showTopFilters: boolean;
   showFilters:boolean;
   showSorting:boolean;
   matchModeOptions: SelectItem[];
   matchModeOptionsForDate: SelectItem[];
   matchModeOptionsForNumeric: SelectItem[];
   showAddRuleButton:boolean = false;
   oldSortField:string = 'createdOn';
   oldSortOrder:string = 'desc';
   sortField:string = 'createdOn';
   sortOrder:string = 'desc';
   appliedFilters:{field:string,matchMode:string,value:string}[]=[];
   pageNo: number =1;
   pageSize: number =10;
   oldPageNo: number =1;
   oldPageSize: number =10;
   totalRecords: number;
   loadEvent: LazyLoadEvent;
   filters;
   filterCondition: { fieldName: string; type: string; }[] =[];
   startSearch: boolean = false;
   searchPageThemeList;
   gridSpinner = 'gridSpinner1';
   isSearchLoading: boolean = false;
   loading: boolean = false;
   searchPageThemeSearchParam:IGlobalSearchParam;
   items: MenuItem[];
   searchPageThemeSearchSpinner = 'searchPageThemeSearchSpinner';
   ref: DynamicDialogRef;
   msgs: Message[] = [];
   dialogPosition = 'topright';
   isSearchPageThemeAdd : boolean = false;
   isSearchPageThemeEdit : boolean = false;
   buttonLabel: string = "";
   title: string = "";
   searchPageThemeForm:FormGroup;
   selectedGridMenuItem:any = null;
   showToggle:boolean;
   isshowpaginator:boolean=true;
   statusValues:any;
   selectedStatusId:any="All";
   selectedStatus:any;
   pageddDisable:boolean= false;
   statusIsActive;
   statusThemeName;
   EditThemeStatusDialog:boolean = false;
   themeEditId;
   allColumns = [
    { value: 'action', header: 'Action' },
    { value: 'themeName', header: 'Theme Name' },
    { value: 'searchPageName', header: 'Search Page' },
    { value: 'isActive', header: 'Is Active' },
    { value: 'createdByName', header: 'Created By' },
    { value: 'createdOn', header: 'Created On' }
  ]

  selectedColumns = [
    { value: 'action', header: 'Action' },
    { value: 'themeName', header: 'Theme Name' },
    { value: 'searchPageName', header: 'Search Page' },
    { value: 'isActive', header: 'Is Active' },
    { value: 'createdByName', header: 'Created By' },
    { value: 'createdOn', header: 'Created On' }
  ]
  

  searchPageNamesList:ILookupCategory;
  searchPageNameLkId: any;
  themeAlreadyExist: boolean = true;
  showIsActive:boolean = true;
  @ViewChild('dt2', { static: true }) table: any;

  constructor(
    public datepipe: DatePipe,
     private spinner: NgxSpinnerService,
     private searchPageThemeService:SearchPageThemeService,
     private dialogService: DialogService,
     private confirmationService: ConfirmationService,
     private messageService: MessageService,
     private primengConfig: PrimeNGConfig,
     private _fb: FormBuilder,
     private excelService:ExcelService,
     private _router: Router,
     public sharedService: SharedService
  ) { 

      this.showFilters = false;
      this.showSorting = false;
      this.spinner.show();
      setTimeout(() => {
          this.spinner.hide();
      }, 1000);
     
    }//constructor


  
    
   ngOnInit(): void {
    this.checkViewPermission();
    this.items = [];
    this.checkEditDeletePermission();

     const customFilterName = "custom-equals";
     const notEquals = "not-equals";
     const dateAfter = "date-after";
     const dateBefore = "date-before";
     
     this.matchModeOptions = [
       { label: "Custom Equals", value: customFilterName },
       { label: "Starts With", value: FilterMatchMode.STARTS_WITH },
       { label: "Contains", value: FilterMatchMode.CONTAINS }
     ];
 
     this.matchModeOptionsForDate = [
      { label: "Equals", value: customFilterName },
      { label: "Not Equals", value: notEquals },
      { label: "Greater Than", value: dateAfter },
      { label: "Less Than", value: dateBefore },
     ];
 
     this.matchModeOptionsForNumeric = [
       { label: "Custom Equals", value: customFilterName },
       { label: "Greater than or equal to", value: FilterMatchMode.GREATER_THAN_OR_EQUAL_TO },
       { label: "Less than or equal to", value: FilterMatchMode.LESS_THAN_OR_EQUAL_TO },
     ];
 
     this.filterCondition=[
       {fieldName:"themeName",type:"basic"},
       {fieldName:"searchPageName",type:"basic"},
       {fieldName:"isActive",type:"basic"},
       {fieldName:"createdByName",type:"basic"},
       {fieldName:"createdOn",type:"date"},
     ];
     this.appliedFilters.push({ field:"globalfilter", matchMode:"equals", value:"0" }) 
     this.getSearchPageNames();
     this.getAllSearchPageThemeList();
     this.statusValues=['All','Active',"Inactive"];
     this.InitialSetup();
   }
   checkViewPermission()
   {
     var result = this.sharedService.checkPermission("Admin_View");
     if(!result)
     this._router.navigateByUrl('/login');
   }
   InitialSetup(){
     this.searchPageThemeForm = this._fb.group({
      themeId: new FormControl(0,[Validators.required]),
      searchPageNameLkId: new FormControl(0,[Validators.required]),
      themeName: new FormControl("",[Validators.required]),
      description: new FormControl(""),
      isActive: new FormControl(false,[Validators.required]),
      createdBy: new FormControl(""),
      createdOn: new FormControl(""),
      modifiedBy: new FormControl(""),
      modifiedOn: new FormControl(""),
      //​createdByUser:new FormControl(""),
      //modifiedByUser:new FormControl(""),
     })
   }

  
   
   getSearchPageNames() {
    //this.categoryName = 'Search Page Names';
      this.sharedService.getLookupMasterByCategoryId(LookupCategory.SearchPageNames).subscribe((data: any) => {
      this.searchPageNamesList = data;
      
    });
  }

  getSearchPageNameOnChange(event) {
    this.searchPageNameLkId = event.value;
    // this.searchPageNameLkId = event.value.lookupOrder;
  }

   getAllSearchPageThemeList()
   {
     this.searchPageThemeSearchParam = 
        {
          pageNo:this.pageNo,
          pageSize:this.pageSize,
          sortField:this.sortField,
          appliedFilters:this.appliedFilters,
          sortOrder:this.sortOrder
        };
        this.spinner.show(this.searchPageThemeSearchSpinner);
     this.searchPageThemeService.getAllSearchPageThemes(this.searchPageThemeSearchParam).subscribe((data: any) => {
       this.appliedFilters = [];
       this.searchPageThemeList =data;
       this.isshowpaginator=this.searchPageThemeList.length>0?true:false;
       this.totalRecords = data[0].totalCount;
       this.spinner.hide(this.searchPageThemeSearchSpinner);
      });
   }
 
 
   loadSearchPageThemeList(event:LazyLoadEvent)
   { 
     this.loadEvent=event;
     if(event.first==0)
     {
       this.pageNo = 1;
     }
     else {
       this.pageNo=(event.first/event.rows)+1;
     }
     this.pageSize=event.rows;
     
     this.pageSize=event.rows;
     
     if((this.oldPageNo != this.pageNo) || (this.oldPageSize != this.pageSize))
     {
      this.applyFilter();
      this.getAllSearchPageThemeList();
     }
     this.oldPageNo = this.pageNo;
     this.oldPageSize = this.pageSize;
     this.filters=event.filters;
     if(this.filters["createdOn"]!= undefined)
     {
     if(this.filters["createdOn"][0].matchMode == "date-after")
     {
        this.showAddRuleButton = true;
     }
     else{
       this.showAddRuleButton = false;
     }
     }
     this.sortField=event.sortField;
     if(event.sortField === undefined|| event.sortField === null)
     {
       this.sortField='createdOn';
     }
     if(event.sortOrder === 1)
     {
     this.sortOrder='desc';
     }
     if(event.sortOrder === -1)
     {
     this.sortOrder='asc';
     }
     /*if(this.sortField !== 'createdOn')
     {
       this.getAllSearchPageThemeList()
     }*/
 
     if(this.oldSortField !==  this.sortField ||  this.oldSortOrder !== this.sortOrder)
     {
       this.applyFilter();
       this.getAllSearchPageThemeList()
     }
     this.oldSortField = this.sortField;
     this.oldSortOrder = this.sortOrder;
   }
 
 
   search()
   {
     for(let i=0;i<this.filterCondition.length;i++)
     {
       if(this.filterCondition[i].type == "checkbox")
       {
         if(this.filters[this.filterCondition[i].fieldName].value == true)
         {
           this.appliedFilters.push({field:this.filterCondition[i].fieldName,matchMode:this.filters[this.filterCondition[i].fieldName].matchMode ,value:"true"}) 
         }
         else if (this.filters[this.filterCondition[i].fieldName].value == false){
           this.appliedFilters.push({field:this.filterCondition[i].fieldName,matchMode:this.filters[this.filterCondition[i].fieldName].matchMode ,value:"false"}) 
         }
       }
       else {
         this.appliedFilters.push({field:this.filterCondition[i].fieldName,matchMode:this.filters[this.filterCondition[i].fieldName].matchMode ,value:this.filters[this.filterCondition[i].fieldName].value}) 
       }
       if(i==this.filterCondition.length-1 )
       {
         this.startSearch = true; 
       } 
     }
     if(this.startSearch == true)
     {
       this.searchPageThemeSearchParam = 
        {
          pageNo:this.pageNo,
          pageSize:this.pageSize,
          sortField:this.sortField,
          appliedFilters:this.appliedFilters,
          sortOrder:this.sortOrder
        };
        this.spinner.show(this.searchPageThemeSearchSpinner);
       this.searchPageThemeService.getAllSearchPageThemes(this.searchPageThemeSearchParam).subscribe((data: any) => {
         this.appliedFilters = [];
         this.searchPageThemeList =data;
         this.totalRecords = data[0].totalCount;
         this.spinner.hide(this.searchPageThemeSearchSpinner);
        });
     }
   }
 
 
 
 
   showSearchPageThemeDetails(paramId: number)
   {
  //    this.ref = this.dialogService.open(SearchPageThemeViewModalComponent, {
  //      header: 'SearchPageTheme Details',
  //      width: '50%',
  //      contentStyle: {"max-height": "500px", "overflow": "auto"},
  //      baseZIndex: 10000,
  //      data: {id: paramId}
  //  });
   }
 
 
 
 
   deleteConfirm(paramId:number) {
     this.dialogPosition = 'topright';
     this.confirmationService.confirm({
       message: 'Do you want to delete this search Page Theme?',
       header: 'Delete Confirmation',
       icon: 'pi pi-info-circle',
       accept: () => {
         this.searchPageThemeService.deleteSearchPageTheme(paramId).subscribe((data: any) => {
           this.getAllSearchPageThemeList();
           this.messageService.add({severity:'info', summary:'Confirmed', detail:'You have deleted the record'});
          });
       },
       reject: (type) => {
         switch(type) {
             case ConfirmEventType.REJECT:
                 this.messageService.add({severity:'error', summary:'Rejected', detail:'You have rejected'});
             break;
             case ConfirmEventType.CANCEL:
                 this.messageService.add({severity:'warn', summary:'Cancelled', detail:'You have cancelled'});
             break;
         }
       },
       key: "positionDialog"
     });
   }
 
   addSearchPageThemeDetails(){
     this.InitialSetup();
     this.showIsActive = true;
     this.pageddDisable = false;
     this.isSearchPageThemeAdd = true;
     this.isSearchPageThemeEdit = false;
     this.title = "Search Page Theme Add";
     this.buttonLabel = "Save";
     this.searchPageNameLkId = undefined;
   }
 
   editSearchPageThemeDetails(paramId: number)
   { 
     this.InitialSetup();
     this.isSearchPageThemeEdit = true;
     this.isSearchPageThemeAdd = false;
     this.title = "Search Page Theme Edit";
     this.buttonLabel = "Update";
     this.pageddDisable = true;
     this.showIsActive = false;
     this.searchPageThemeService.getSearchPageThemeById(paramId).subscribe((data:SearchPageTheme) =>{
      console.log(data);
       //this.searchPageThemeForm.patchValue(data[0]);
      
       this.searchPageThemeForm.patchValue(data);
       this.searchPageNameLkId = data.searchPageNameLkId;
     },error => {
       console.log(error)
     })
   }
   editSearchPageThemeIsActive(paramId: number)
   { 
    this.EditThemeStatusDialog = true;
    this.searchPageThemeService.getSearchPageThemeById(paramId).subscribe((data:SearchPageTheme) =>{
      console.log(data);
      this.themeEditId = data.themeId;
      this.statusThemeName =data.themeName;
      this.statusIsActive = data.isActive;
    });
   }
   updateThemeStatus()
   {
    this.loggedInUserProfile = this.sharedService.getLoggedInUserProfile();
    this.searchPageThemeService.updateThemeStatus(this.themeEditId,this.statusIsActive,this.loggedInUserProfile.uid).subscribe((data:any)=>{
      this.EditThemeStatusDialog = false;
      //this.appliedFilters=[];
      this.getAllSearchPageThemeList();
    });
   }
   cancel(){
     this.isSearchPageThemeAdd = false;
     this.isSearchPageThemeEdit = false;
     this.searchPageNameLkId = undefined;
     this.InitialSetup();
   }
 
   save({value}: {value: SearchPageTheme}){
    this.searchPageThemeService.checkSearchPageThemeExists(value.themeName,value.searchPageNameLkId).subscribe((data: any) => {
      this.themeAlreadyExist = data;
      if (data == false) {
        this.saveConfirm({value});
      }
      else{
        this.showThemeAlreadyExistMessage();
      }
    });

    //this.checkSearchPageThemeExists(value.searchPageNameLkId, value.themeName);
    
    //  if(value.themeId === 0){
    //    value.createdBy = 1;
    //    value.createdOn = new Date();
    //    this.searchPageThemeService.postSearchPageTheme(value).subscribe(data => {
    //     this.showSaveSuccess();
    //      this.getAllSearchPageThemeList();
    //      this.isSearchPageThemeAdd = false;
    //    }, error => {
    //      console.log(error)
    //    })
    //  }else{
    //    this.searchPageThemeService.updateSearchPageTheme(value.themeId, value).subscribe(data => {
    //     this.showUpdateSuccess();
    //      this.getAllSearchPageThemeList();
    //      this.isSearchPageThemeEdit = false;
    //    }, error => {
    //      console.log(error);
    //    })
    //  }
   }

   saveConfirm({value}: {value: SearchPageTheme}){
    this.loggedInUserProfile = this.sharedService.getLoggedInUserProfile();
    if(value.themeId === 0){
      value.createdBy = this.loggedInUserProfile.uid;
      value.createdOn = new Date();
      this.searchPageThemeService.postSearchPageTheme(value).subscribe(data => {
        this.searchPageNameLkId = null;
       this.showSaveSuccess();
        this.getAllSearchPageThemeList();
        this.isSearchPageThemeAdd = false;
      }, error => {
        console.log(error)
      })
    }else{
      this.searchPageThemeService.updateSearchPageTheme(value.themeId, value).subscribe(data => {
        this.searchPageNameLkId = null;
       this.showUpdateSuccess();
        this.getAllSearchPageThemeList();
        this.isSearchPageThemeEdit = false;
      }, error => {
        console.log(error);
      })
    }
  }
   showSaveSuccess() {
    this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Theme created successfully' });
  }

  showUpdateSuccess() {
    this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Theme updated successfully' });
  }

  showThemeAlreadyExistMessage() {
    this.messageService.add({ severity: 'warn', summary: 'Error', detail: 'Sorry, theme name already exist' });
  }
 
   clearFilter(table: Table) {
    for (let i = 0; i < this.filterCondition.length; i++) {
      if (this.table.filters[this.filterCondition[i].fieldName] != undefined) {
       this.table.filters[this.filterCondition[i].fieldName][0].value = null;
      }
    }
     table.clear();
     this.appliedFilters = [];
    //  this.applyFilter();
     this.clearStatus();
    this.getAllSearchPageThemeList();
   }
   
   bindShowFilter() {
     this.showFilters = (this.showFilters ? false : true)
   }
 
   bindShowSorting() {
     this.showSorting = (this.showSorting ? false : true)
   }
 
   bindShowTopFilter() {
     this.showTopFilters = (this.showTopFilters ? false : true)
   }
 
   applyFilterNew(table: Table){
     this.filters=table.filters;
     this.applyFilter();
   }
 
   applyFilter()
   {
     if (Object.keys(this.filters).length > 1) {
       this.appliedFilters = [];
       for (let i = 0; i < this.filterCondition.length; i++) {
         if (this.filterCondition[i].type == "checkbox") {
           if (this.filters[this.filterCondition[i].fieldName] !== undefined) {
             if (this.filters[this.filterCondition[i].fieldName][0].value == true) {
               this.appliedFilters.push({
                 field: this.filterCondition[i].fieldName,
                 matchMode: this.filters[this.filterCondition[i].fieldName][0].matchMode,
                 value: "true"
               })
             }
             else if (this.filters[this.filterCondition[i].fieldName][0].value == false) {
               this.appliedFilters.push({
                 field: this.filterCondition[i].fieldName,
                 matchMode: this.filters[this.filterCondition[i].fieldName][0].matchMode,
                 value: "false"
               })
             }
           }
         }
         else if (this.filterCondition[i].type == "basic") {
           if (this.filters[this.filterCondition[i].fieldName] !== undefined) {
             if (this.filters[this.filterCondition[i].fieldName][0].value !== null) {
               this.appliedFilters.push({
                 field: this.filterCondition[i].fieldName,
                 matchMode: this.filters[this.filterCondition[i].fieldName][0].matchMode,
                 value: this.filters[this.filterCondition[i].fieldName][0].value
               })
             }
           }
         }
         else if (this.filterCondition[i].type == "date") {
           if (this.filters[this.filterCondition[i].fieldName] !== undefined) {
             for (let j = 0; j <= this.filters[this.filterCondition[i].fieldName].length - 1; j++) {
               if (this.filters[this.filterCondition[i].fieldName][j].value !== null)
                 this.appliedFilters.push({
                   field: this.filterCondition[i].fieldName,
                   matchMode: this.filters[this.filterCondition[i].fieldName][j].matchMode,
                   value: this.datepipe.transform(this.filters[this.filterCondition[i].fieldName][j].value,"MM-dd-yyyy")
                 })
             }
           }
         }
         else if (this.filterCondition[i].type == "numeric") {
           if (this.filters[this.filterCondition[i].fieldName] !== undefined) {
             if (this.filters[this.filterCondition[i].fieldName][0].value !== null)
               this.appliedFilters.push({
                 field: this.filterCondition[i].fieldName,
                 matchMode: this.filters[this.filterCondition[i].fieldName][0].matchMode,
                 value: this.filters[this.filterCondition[i].fieldName][0].value
               })
           }
         }
     }
     }
 
     if(this.startSearch == true || this.startSearch == false)
     {
       this.searchPageThemeSearchParam = 
        {
          pageNo:this.pageNo,
          pageSize:this.pageSize,
          sortField:this.sortField,
          appliedFilters:this.appliedFilters,
          //searchGlobalFilter: this.searchGlobalFilter,
          sortOrder:this.sortOrder
        };
       this.spinner.show(this.searchPageThemeSearchSpinner);
       this.searchPageThemeService.getAllSearchPageThemes(this.searchPageThemeSearchParam).subscribe((data: any) => {
       this.searchPageThemeList =data;
       this.isshowpaginator=this.searchPageThemeList.length>0?true:false;
       this.totalRecords = data[0].totalCount;
       this.spinner.hide(this.searchPageThemeSearchSpinner);
       });
     }
   }



  //  exportExcel() {
  //   let header = ['Lookup Category Name', 'Description', 'Is Active', 'Created By', 'Created On'];
  //   let jsonKey = ['categoryName', 'description', 'isActive', 'createdByUser', 'createdOn'];
  //   let data = this.searchPageThemeList;
  //   var arrFinalData = [];
  //   var columnsKeyNames = [];
  //   for (var i = 0; i < data.length; i++) {
  //     var singleRow_temp = data[i];
  //     columnsKeyNames = Object.keys(singleRow_temp);
  //     var column0_temp = "";
  //     var column1_temp = "";
  //     var column2_temp = "";
  //     var column3_temp = "";
  //     var column4_temp = "";
  //     for (var j = 0; j < columnsKeyNames.length; j++) {
  //       if (columnsKeyNames[j] == jsonKey[0]) {
  //         column0_temp = singleRow_temp[columnsKeyNames[j]];
  //       }
  //       if (columnsKeyNames[j] == jsonKey[1]) {
  //         column1_temp = singleRow_temp[columnsKeyNames[j]];
  //       }
  //       if (columnsKeyNames[j] == jsonKey[2]) {
  //         if(singleRow_temp[columnsKeyNames[j]] == true){
  //           column2_temp = 'ACTIVE';
  //         }
  //         if(singleRow_temp[columnsKeyNames[j]] == false){
  //           column2_temp = 'INACTIVE';
  //         }
  //       }
  //       if (columnsKeyNames[j] == jsonKey[3]) {
  //         column3_temp = singleRow_temp[columnsKeyNames[j]].firstName;
  //       }
  //       if (columnsKeyNames[j] == jsonKey[4]) {
  //         column4_temp = this.datepipe.transform(singleRow_temp[columnsKeyNames[j]],'MM/dd/yyyy');
  //       }
  //     }
  //     arrFinalData.push([column0_temp,column1_temp,column2_temp,column3_temp,column4_temp])
  //   }
  //   this.excelService.exportExcel(header,arrFinalData,'lookup-category-search')
  // }



  bindShowToggle() {
    this.showToggle = (this.showToggle ? false : true)
  }

  showAndHideColumn(event){
    this.selectedColumns = event.value;
  }

  isShowColumns(columnName){
    var tempColumn = this.selectedColumns.filter(col => col.value == columnName);
    if(tempColumn.length == 1){
      return true;
    }
    return false;
  }

  checkEditDeletePermission() {
    var isAdminAdd = this.sharedService.checkPermission("Admin_Add");
    var isAdminDelete = this.sharedService.checkPermission("Admin_Delete");
    if (isAdminAdd) {
      var editItem = {
        label:'Edit',
        icon:'pi pi-fw pi-pencil',
        command: e => this.editSearchPageThemeDetails(this.selectedGridMenuItem.themeId)
      }
      this.items.push(editItem)
    }
    if (isAdminAdd) {
      var editItemIsActive = {
        label:'Edit Status',
        icon:'pi pi-fw pi-pencil',
        command: e => this.editSearchPageThemeIsActive(this.selectedGridMenuItem.themeId)
      }
      this.items.push(editItemIsActive)
    }
    if(isAdminDelete){
      var deleteItem =  {
        label:'Delete',
        icon:'pi pi-fw pi-trash',
        command: e => this.deleteConfirm(this.selectedGridMenuItem.themeId)
       }
       this.items.push(deleteItem);
    }
  }

 getStatusOnChange(event)
 {
  this.selectedStatusId = event.value;
  this.selectedStatus=event.value;
 }

 clearStatus()
 {
  this.selectedStatus ="";
  this.selectedStatusId = undefined;
 }
 
 exportSearchPageTheme() {
  this.applyFilter();
  this.searchPageThemeSearchParam = 
  {
    pageNo:this.pageNo,
    pageSize:this.pageSize,
    sortField:this.sortField,
    appliedFilters:this.appliedFilters,
    sortOrder:this.sortOrder
  };
  this.searchPageThemeService.ExportSearchPageTheme(this.searchPageThemeSearchParam).subscribe(res => {
  var blob = new Blob([res.body], { type: res.body.type });
  const file = new File([blob],"SearchPageTheme.xlsx", { type: res.body.type });
  fs.saveAs(file);
  });
}


// checkSearchPageThemeExists(searchPageId:number,themeName:string) {
//   this.searchPageThemeService.checkSearchPageThemeExists(searchPageId, themeName).subscribe((data: any) => {
//     this.themeAlreadyExist = data;
//     if (data == true) {
//       this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Already users assigned to this theme' });
//       console.log('themeAlreadyExist', data);
//     }

//   });
//}







}//class
